// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {DropMenuEl} from 'common/components/drop-menu';
import {ItemsMenuEl} from 'common/components/items-menu';
import {TagEl} from 'common/components/tag';
import {ButtonTheme} from 'common/components/button/constants';

import type {FilterBarComplexFilter} from './index';

export function template(this: FilterBarComplexFilter) {
  const {open} = this.state;

  return (
    <div sel='.complex-filter'>
      <div sel='.complex-filter-display'>
        <ButtonEl
          attrs={{
            icon: `filter`,
            theme: ButtonTheme.Tertiary,
          }}
          on={{click: this.helpers.clickedFilterButton}}
        >
          Filter
          <TagEl
            sel='.complex-filter-count'
            attrs={{
              'tag-name': this.helpers.getSelectedItems().length.toString(),
            }}
          />
        </ButtonEl>
      </div>
      <DropMenuEl
        attrs={{
          open,
        }}
        on={{change: this.helpers.handleMenuChange}}
      >
        <ItemsMenuEl
          attrs={{
            multiple: true,
          }}
          props={{
            sections: this.attr(`sections`),
          }}
          on={{
            clickItem: this.helpers.handleFilterItemClick,
          }}
        />
      </DropMenuEl>
    </div>
  );
}
